import I, { ImmutableObject } from 'seamless-immutable';
import { CoursesStoreEnum } from './types';

export function coursesStoreAdapter(): ImmutableObject<Record<CoursesStoreEnum, any>> {
  return I({
    [CoursesStoreEnum.COURSES]: []
  });
}
